import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../TextInput/TextInput';
import Button from '../Button/Button';

/**
 * This component is based on the TextInput component and interacts with the same properties.
 * It is extended with a cancel button to clear the input value and focus on the input element.
 */

const TextInputReset = ({
  placeholder = '',
  inputValue = '',
  onChange = null,
  ref = null,
  ...InputAttributes
}) => {
  const [inputText, setInputText] = useState(inputValue);

  useEffect(() => {
    if (inputValue !== inputText) {
      setInputText(inputValue);
    }
  }, [inputValue]);

  const onInputTextChange = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setInputText(value);
    if (onChange) onChange(value);
  };

  const onClickRightElement = () => {
    setInputText('');
    ref.current.focus();
    if (onChange) onChange('');
  };

  const clearElement = (
    <Button
      contentType="icon"
      size="small"
      icon="cancel"
      type="button"
      dataAttributes={{
        'data-test-button': 'text-clear-input'
      }}
      onClick={onClickRightElement}
    />
  );

  return (
    <TextInput
      {...InputAttributes}
      inputValue={inputText}
      onChange={onInputTextChange}
      ref={ref}
      rightElement={inputText.length ? clearElement : null}
      placeholder={placeholder}
    />
  );
};

TextInputReset.propTypes = {
  /** Passed through input value */
  inputValue: PropTypes.string,
  /** Fill in a placeholder text  */
  placeholder: PropTypes.string,
  /** onChange event for input field */
  onChange: PropTypes.func,
  /** Forwarded to the underlying input element, used to focus it after clearing */
  ref: PropTypes.shape({})
};

export default TextInputReset;
